/* eslint-disable no-unused-vars */
import axios from "axios";

const state = {};

const getters = {};

const actions = {
  getSubCriterias({ commit }, payload) {
    return axios
      .get(
        process.env.VUE_APP_API_URL +
          "/subkriteria/get_by.php?kriteria=" +
          payload
      )
      .then(res => res.data);
  },
  storeSubCriteria: async ({ commit }, payload) => {
    try {
      const res = await axios.post(
        process.env.VUE_APP_API_URL + "/subkriteria/create.php",
        {
          kriteria: payload.criteria,
          subkriteria: payload.subcriteria
        }
      );
      commit("SET_SNACKBAR", {
        visibility: true,
        color: res.data.success ? "success" : "error",
        text: res.data.message
      });
      return res.data.success;
    } catch (err) {
      commit("SET_SNACKBAR", {
        visibility: true,
        color: "error",
        text: err
      });
      return false;
    }
  },
  updateSubCriteria: async ({ commit }, payload) => {
    try {
      const res = await axios.post(
        process.env.VUE_APP_API_URL + "/subkriteria/update.php",
        {
          id: payload.id,
          subkriteria: payload.subcriteria
        }
      );
      commit("SET_SNACKBAR", {
        visibility: true,
        color: res.data.success ? "success" : "error",
        text: res.data.message
      });
      return res.data.success;
    } catch (err) {
      commit("SET_SNACKBAR", {
        visibility: true,
        color: "error",
        text: err
      });
      return false;
    }
  },
  deleteSubCriteria: async ({ commit }, payload) => {
    try {
      const res = await axios.post(
        process.env.VUE_APP_API_URL + "/subkriteria/delete.php",
        {
          id: payload
        }
      );
      commit("SET_SNACKBAR", {
        visibility: true,
        color: res.data.success ? "success" : "error",
        text: res.data.message
      });
      return res.data.success;
    } catch (err) {
      commit("SET_SNACKBAR", {
        visibility: true,
        color: "error",
        text: err
      });
      return false;
    }
  },
  validasi: async ({ commit }, payload) => {
    try {
      const res = await axios.post(
        process.env.VUE_APP_API_URL + "/subkriteria/validasi.php",
        {
          id: payload
        }
      );
      commit("SET_SNACKBAR", {
        visibility: true,
        color: res.data.success ? "success" : "error",
        text: res.data.message
      });
      return res.data.success;
    } catch (err) {
      commit("SET_SNACKBAR", {
        visibility: true,
        color: "error",
        text: err
      });
      return false;
    }
  },
  getStatusValidasi: async ({ commit }, payload) => {
    try {
      const res = await axios.get(
        process.env.VUE_APP_API_URL + "/subkriteria/find_one.php?id=" + payload
      );
      return res.data;
    } catch (err) {
      commit("SET_SNACKBAR", {
        visibility: true,
        color: "error",
        text: err
      });
      return {};
    }
  }
};

const mutations = {
  SET_SUBCRITERIAS: (state, payload) => {
    state.subcriterias = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
